function setTitle(title) {
  document.title = `Barbolão${title ? ` - ${title}` : ''}`;
}

export default {
  setTitle,
};
